import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary';
  children?: React.ReactNode;
}
export function CTAButton({
  className = '',
  variant = 'primary',
  children
}: CTAButtonProps) {
  const styles = variant === 'primary' ? 'bg-cta hover:bg-cta-hover text-white shadow-lg' : 'bg-transparent border-2 border-amber text-amber hover:bg-amber hover:text-navy shadow-sm';
  return <motion.a href="https://www.otrdigitalpro.com/cart/45961183789253:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block cursor-pointer font-bold py-4 px-8 rounded-xl transition-colors duration-300 text-lg md:text-xl w-full md:w-auto text-center ${styles} ${className}`} data-id="element-13">
      {children ?? 'DESCARGAR EL PROTOCOLO AHORA — $14.97'}
    </motion.a>;
}